import kman from '../../../assets/imgs/finished/kman.webp';
import mertojak from '../../../assets/imgs/finished/mertojak.webp';
import kila from '../../../assets/imgs/finished/kila.webp';
import brda from '../../../assets/imgs/finished/brda.webp';
import solin from '../../../assets/imgs/finished/solin.webp';
import pazdigrad from '../../../assets/imgs/finished/pazdigrad.webp';
import znjan from '../../../assets/imgs/finished/znjan.webp';

type Project = {
  title: string;
  imgPath: string;
  apartments: string;
  parking: string;
  additional?: string;
};

const KMAN: Project = {
  title: 'PROJEKT KMAN',
  imgPath: kman,
  apartments: '42 stambene jedinice',
  parking: '47 garaža',
};

const MERTOJAK: Project = {
  title: 'PROJEKT MERTOJAK',
  imgPath: mertojak,
  apartments: '21 stambena jedinica',
  parking: '22 garaže',
};

const KILA: Project = {
  title: 'PROJEKT KILA',
  imgPath: kila,
  apartments: '156 stambenih jedinica',
  parking: '154 garaže',
  additional: '3 poslovna prostora',
};

const BRDA: Project = {
  title: 'PROJEKT BRDA',
  imgPath: brda,
  apartments: '56 stambenih jedinica',
  parking: '60 garaža',
  additional: '3 poslovna prostora',
};

const SOLIN: Project = {
  title: 'PROJEKT SOLIN',
  imgPath: solin,
  apartments: '25 stambenih jedinica',
  parking: '2 garaže',
};

const PAZDIGRAD: Project = {
  title: 'PROJEKT PAZDIGRAD',
  imgPath: pazdigrad,
  apartments: '19 stambenih jedinica',
  parking: '20 garaža',
  additional: '2 poslovna prostora',
};

const ZNJAN: Project = {
  title: 'PROJEKT ZNJAN',
  imgPath: znjan,
  apartments: '17 stambenih jedinica',
  parking: '28 garaža',
};

export const finishedProjects: Array<Project> = [
  KMAN,
  MERTOJAK,
  KILA,
  SOLIN,
  BRDA,
  PAZDIGRAD,
  ZNJAN,
];
